// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.boxStart{\n    margin-top: 3%;\n}\n\n\n#logo {\n    width: 9%;\n    margin-bottom: 42px;\n    background: #4575B4;\n    border-radius: 20px;\n    padding: 5px;\n}\n\n.home_title {\n    padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
